import React from 'react';
import {Edit} from 'react-admin';
import RecipeForm from "./RecipeForm";
import resource from "../../config/resource";
import usePermission from "../../components/permission/usePermission";

const RecipeEdit = (props) => {
    const hasPermission = usePermission();
    const onlyHasRecipeAdminPermission = !hasPermission(`${resource.recipe}.edit.status.base`)
    return (
        <Edit {...props} transform={data => ({...data,status:onlyHasRecipeAdminPermission ? 'nutritionVerification' : data.status})}>
            <RecipeForm/>
        </Edit>
    );
};

export default RecipeEdit;